import TagSVG from "@design-system/ui-icons/vanilla/Tag"
import { createIcon } from "../createIcon"

export const TagIcon = createIcon(TagSVG)
